// store index.js

import {getToken,setToken,setUserInfo,getUserInfo,setIsPopThirdBindWindow,getIsPopThirdBindWindow} from '@/utils/auth'
import Vuex from 'vuex'
import Vue from 'vue';
import httpRequest from '@/server/http-api'
Vue.use(Vuex);

const state = {
  userInfo: getUserInfo(),
  token: getToken(),
  loginStatus: !!getToken(),
  alreadyPop: getIsPopThirdBindWindow()
}

const mutations = {
  SET_TOKEN: (state,data) => {
    state.token = data.token;
    setToken(data.token)
    // setToken(data.token,data.isAutoLogin);
  },
  GET_USER: (state,data) => {
    state.userInfo = data;
    setUserInfo(data);
  },
  LOGIN: (state,data) => {
    // state.loginStatus = data;
  },
  LOGOUT: (state) => {
    state.token = false;
    state.user = false;
    state.loginStatus = false;
    setToken(false);
    setUserInfo(false);
  },
  NOTE_IS_POP_THIR_DBIND: (state, status) => {
    state.alreadyPop = status;
    setIsPopThirdBindWindow(status);
  }
}

const actions = {
  reqUpdateUserInfo: function({commit},data) {
    //  alert(111);
    httpRequest.getUserInfo()
      .then(res => {
       
        // console.log("---------------actions------获取的用户信息------");
        // console.log(JSON.stringify(res));
        if (res.code == 200) {
          let userObj = res.data;
          let userInfo = {
            realname: userObj.realname || '',
            avatar: userObj.avatar || null,
            nickname: userObj.nickname || '',
            gender: userObj.gender || '',
            gradeId : (userObj.grade &&  userObj.grade.id) || '',
            gradeName : (userObj.grade &&  userObj.grade.name) || '',
            phone :  userObj.phone || '',
            is_bind_weixin: userObj.is_bind_weixin || 0
          };

          commit('GET_USER',userInfo);
        }
      })
      .catch(err => {
        console.log(JSON.stringify(err) );
      });
  },
}

export default new Vuex.Store({
  state,
  mutations,
  actions
})



// WEBPACK FOOTER //
// ./src/store/index.js